import { ProductForm } from "../ProductForm";

export interface AddProductProps {}

export const AddProduct = () => {
  return <ProductForm />;
};
